/* src/modules/tutors/cards/ViewDocumentsCard/styles.js */

export default theme => ({
  card: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 1000,
    transform: 'translate(-50%, -50%)',
  },
  content: {
    flexDirection: 'row',
    display: 'flex',
    flex: 1,
    minHeight: 500,
    justifyContent: 'center',
  },
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    display: 'flex',
  },
  image: {
    pointerEvents: 'none',
  },
  blank: {
    flex: 1,
    justifyContent: 'center',
    width: 800,
    alignItems: 'center',
  },
  message: {
    marginLeft: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    color: 'gray',
  },
});



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/ViewSignatureCard/styles.js